import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["lang"];
const _hoisted_2 = { class: "df-shell" };
const _hoisted_3 = {
    key: 0,
    class: "df-shell__header"
};
const _hoisted_4 = { class: "df-shell__body" };
import { computed, nextTick, provide, reactive, ref, watch } from "vue";
import { documentToConfig } from "./config/fromDocument";
import { provideDonation } from "./context/donationContext";
import { SubmitErrorKey } from "./context/submitError";
import LanguageToggle from "./components/layout/LanguageToggle.vue";
import DonationCard from "./components/layout/DonationCard.vue";
import DonationBanner from "./components/layout/DonationBanner.vue";
import StepProgress from "./components/layout/StepProgress.vue";
import LegalNotice from "./components/layout/LegalNotice.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationForm',
    props: {
        document: {},
        previewMode: { type: Boolean, default: false },
        initialLocale: { default: undefined },
        onSubmit: { type: Function, default: undefined },
        submitError: { default: null },
        showLangToggle: { type: Boolean, default: undefined },
        utm: { default: undefined },
        attributionToken: { default: undefined }
    },
    emits: ["submit", "error", "step-change", "locale-change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        // SYNC: see ./_SYNC.md.
        const POSITION_CLASSES = {
            FullWidth: "df-root--fill",
            Left: "df-root--boxed df-root--left",
            Center: "df-root--boxed df-root--center",
            Right: "df-root--boxed df-root--right",
        };
        const props = __props;
        const emit = __emit;
        const config = reactive(documentToConfig(props.document, { previewMode: props.previewMode }));
        watch(() => [props.document, props.previewMode], () => Object.assign(config, documentToConfig(props.document, { previewMode: props.previewMode })), { deep: true });
        const onSubmit = async (request, ctx) => {
            emit("submit", request);
            if (props.onSubmit) {
                await props.onSubmit(request, ctx);
            }
        };
        const ctx = provideDonation(config, {
            initialLocale: props.initialLocale,
            utm: props.utm,
            attributionToken: props.attributionToken,
            onSubmit,
            onError: (err) => emit("error", err),
        });
        provide(SubmitErrorKey, computed(() => props.submitError ?? null));
        const { themeVars, isTerminalStep, currentStepId, availableLangs, lang } = ctx;
        __expose({ resetSubmit: ctx.resetSubmit });
        watch(currentStepId, (id) => emit("step-change", id));
        const root = ref(null);
        // Keep non-immediate: focus must not move on mount (nor on the preview's :key remount).
        watch(currentStepId, async () => {
            await nextTick();
            root.value
                ?.querySelector(".df-step__title, .df-complete__title")
                ?.focus();
        });
        const positionClass = computed(() => POSITION_CLASSES[config.formPosition]);
        const showToggle = computed(() => props.showLangToggle !== false && availableLangs.value.length > 1);
        function onLocaleChange(code) {
            emit("locale-change", code);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "root",
                ref: root,
                class: _normalizeClass(["df-root", positionClass.value]),
                lang: _unref(lang),
                style: _normalizeStyle(_unref(themeVars))
            }, [
                _createElementVNode("div", _hoisted_2, [
                    (showToggle.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(LanguageToggle, { onLocaleChange: onLocaleChange })
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createVNode(DonationCard, { class: "df-shell__card" }, {
                        default: _withCtx(() => [
                            _createVNode(DonationBanner),
                            _createElementVNode("div", _hoisted_4, [
                                (!_unref(isTerminalStep))
                                    ? (_openBlock(), _createBlock(StepProgress, {
                                        key: 0,
                                        class: "df-shell__progress"
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ctx).currentStep.value.component))),
                                (!_unref(isTerminalStep))
                                    ? (_openBlock(), _createBlock(LegalNotice, { key: 1 }))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1));
        };
    }
});
